import { videos } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

export default function LatestSection() {
  const latest = videos.filter((v) => v.latest).slice(0, 8);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-5 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新最热的精彩内容</p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {latest.map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}